"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotQuery = exports.CachedSlotToQueryIndexedDb = exports.DashSlotIndexedDB = exports.DashUserIndexedDB = exports.slotToCachedQueryStore = exports.cachedQueriesStore = exports.dashSlotStore = exports.dashUserStore = exports.summaryDb = void 0;
exports.calcCachedSlotToQueryKey = calcCachedSlotToQueryKey;
exports.dashUserCacheId = dashUserCacheId;
exports.dashUserToCacheable = dashUserToCacheable;
exports.dashSlotToCacheable = dashSlotToCacheable;
exports.cacheSlots = cacheSlots;
exports.cacheUsers = cacheUsers;
exports.calcSlotQueryDbKey = calcSlotQueryDbKey;
const IndexedDBStorage_1 = require("./IndexedDBStorage");
exports.summaryDb = "SummaryDb";
exports.dashUserStore = "DashUserStore";
exports.dashSlotStore = "DashSlotStore";
exports.cachedQueriesStore = "CachedQueriesStore";
exports.slotToCachedQueryStore = "SlotToCachedQueryStore";
class DashUserIndexedDB {
    data;
    constructor(d) {
        this.data = d;
    }
    getStoreName() {
        return exports.dashUserStore;
    }
    getKey() {
        return this.data.id;
    }
    toJSON() {
        return this.data;
    }
    ;
}
exports.DashUserIndexedDB = DashUserIndexedDB;
class DashSlotIndexedDB {
    data;
    constructor(d) {
        this.data = d;
    }
    getStoreName() {
        return exports.dashSlotStore;
    }
    getKey() {
        return this.data.id;
    }
    toJSON() {
        return this.data;
    }
    ;
}
exports.DashSlotIndexedDB = DashSlotIndexedDB;
function calcCachedSlotToQueryKey(slotId, queryKey) {
    return `${slotId}-${queryKey}`;
}
class CachedSlotToQueryIndexedDb {
    slotId;
    queryKey;
    constructor(slotId, queryKey) {
        this.slotId = slotId;
        this.queryKey = queryKey;
    }
    getStoreName() {
        return exports.slotToCachedQueryStore;
    }
    getKey() {
        return calcCachedSlotToQueryKey(this.slotId, this.queryKey);
    }
    toJSON() {
        return {
            slotId: this.slotId,
            queryKey: this.queryKey,
        };
    }
    ;
}
exports.CachedSlotToQueryIndexedDb = CachedSlotToQueryIndexedDb;
function dashUserCacheId(branchId, userId) {
    return `${branchId}-${userId}`;
}
function dashUserToCacheable(du) {
    return {
        id: dashUserCacheId(du.branchId, du.userId),
        userId: du.userId,
        branchUserId: du.branchUserId,
        name: du.name,
        branchId: du.branchId,
        wage: du.wage,
        transport: du.transport,
        isFake: du.isFake,
        isDeleted: du.isDeleted,
        memo: du.memo,
        tags: du.tags,
        isBranchOwner: du.isBranchOwner,
        isHelp: du.isHelp,
        minMonthLaborMinutes: du.minMonthLaborMinutes,
        maxMonthLaborMinutes: du.maxMonthLaborMinutes,
        maxMonthVacationDays: du.maxMonthVacationDays,
        minWeekLaborMinutes: du.minWeekLaborMinutes,
        maxWeekLaborMinutes: du.maxWeekLaborMinutes,
        isHiddenInShift: du.isHiddenInShift,
        cachedAtMs: new Date().valueOf(),
        weeklyLimit: du.weeklyLimit,
    };
}
function dashSlotToCacheable(ds) {
    const sectionSlots = [];
    for (const s of ds.sectionSlots) {
        sectionSlots.push(dashSlotToCacheable(s));
    }
    return {
        id: ds.id,
        from: ds.from,
        fromMs: new Date(ds.from).valueOf(),
        to: ds.to,
        type: ds.type,
        purpose: ds.purpose,
        hideFrom: ds.hideFrom,
        hideTo: ds.hideTo,
        isLocked: ds.isLocked,
        rest: ds.rest,
        userId: ds.userId,
        branchId: ds.branchId,
        groupId: ds.groupId,
        askStatus: ds.askStatus,
        createdTimeUnix: ds.createdTimeUnix,
        updatedTimeUnix: ds.updatedTimeUnix,
        color: ds.color,
        commentCount: ds.commentCount,
        sectionIds: ds.sectionIds,
        sectionSlots: sectionSlots,
        parentSlotId: ds.parentSlotId,
        isAuto: ds.isAuto,
        isEdited: ds.isEdited,
        isHelp: ds.isHelp,
        isRead: ds.isRead,
        isKotSynced: ds.isKotSynced,
        memo: ds.memo,
        numComments: ds.numComments,
        roleId: ds.roleId,
        linkPrev: ds.linkPrev,
        linkNext: ds.linkNext,
        isRepeat: ds.isRepeat,
        createdBy: ds.createdBy,
        wage: ds.wage,
        alert: ds.alert,
        repeatKey: ds.repeatKey,
        repeatUntil: ds.repeatUntil,
        repeatExclude: ds.repeatExclude,
        repeatLocked: ds.repeatLocked,
        requestedSlotId: ds.requestedSlotId,
        requestedSlot: ds.requestedSlot ? dashSlotToCacheable(ds.requestedSlot) : null,
        managedSlotId: ds.managedSlotId,
        label: ds.label,
        fromLabel: ds.fromLabel,
        fromUnix: ds.fromUnix,
        toUnix: ds.toUnix,
        toLabel: ds.toLabel,
        date: ds.date,
        dateLabel: ds.dateLabel,
        dateUnix: ds.dateUnix,
        roleName: ds.roleName,
        userName: ds.userName,
        branchName: ds.branchName,
        createdTime: ds.createdTime,
        updatedTime: ds.updatedTime,
        requestedSlotKey: ds.requestedSlotKey,
        managedSlotKey: ds.managedSlotKey,
        cachedAtMs: new Date().valueOf(),
        updatedAt: ds.updatedAt,
    };
}
const MAX_BATCH_SIZE = 1000;
// cacheSlots accepts a list of DashSlots and batches them into IndexedDB put all calls.
// Because caching can be costly, this function should called by a worker when possible.
// If workers are not available it can be run synchronously.
async function cacheSlots(slots, queryKey) {
    const db = new IndexedDBStorage_1.IndexedDBStorage(exports.summaryDb);
    for (let i = 0; i < slots.length; i += MAX_BATCH_SIZE) {
        const batch = slots.slice(i, i + MAX_BATCH_SIZE);
        const toPut = [];
        for (const s of batch) {
            toPut.push(new DashSlotIndexedDB(dashSlotToCacheable(s)));
            toPut.push(new CachedSlotToQueryIndexedDb(s.id, queryKey));
        }
        await db.putAllMultiStore(toPut);
    }
}
// cacheUsers accepts a list of DashUsers and batches them into IndexedDB put all calls.
// Because caching can be costly, this function should called by a worker when possible.
// If workers are not available it can be run synchronously.
async function cacheUsers(users) {
    const db = new IndexedDBStorage_1.IndexedDBStorage(exports.summaryDb);
    for (let i = 0; i < users.length; i += MAX_BATCH_SIZE) {
        const batch = users.slice(i, i + MAX_BATCH_SIZE);
        const toPut = [];
        for (const u of batch) {
            toPut.push(new DashUserIndexedDB(dashUserToCacheable(u)));
        }
        await db.putAll(toPut);
    }
}
class SlotQuery {
    key;
    updatedAt;
    constructor(key, updatedAt) {
        this.key = key;
        this.updatedAt = updatedAt;
    }
    getStoreName() {
        return exports.cachedQueriesStore;
    }
    getKey() {
        return this.key;
    }
    toJSON() {
        return {
            updatedAt: this.updatedAt,
        };
    }
    ;
}
exports.SlotQuery = SlotQuery;
function calcSlotQueryDbKey(branchId, startDate, endDate, roleIds, lockedOnly) {
    const params = new URLSearchParams();
    params.append("branchID", branchId.toString());
    params.append("fromGte", startDate.toISOString());
    params.append("fromLt", endDate.toISOString());
    if (roleIds === "all") {
        params.append("roleIDs", "all");
    }
    else if (roleIds.length) {
        params.append("roleIDs", roleIds.join(","));
    }
    if (lockedOnly) {
        params.append("isLocked", lockedOnly.toString());
    }
    return params.toString();
}
